import { clientbookApi } from '../core/clientbook-api';

/**
 * Get all stores for the merchant
 * @param {Object} options
 * @param {boolean} options.loadingStatusOff - Disable loading indicator
 * @param {Object} options.query - Query parameters (limit, offset)
 */
export const getMerchantStores = async ({ loadingStatusOff = false, query = {} } = {}) => {
  return clientbookApi.get({
    url: '/merchants/stores',
    query: {
      limit: 500,
      offset: 0,
      ...query,
    },
    loading: !loadingStatusOff,
  });
};

export const getStoreHoursByDate = async ({ storeId, query, loading = false, options = {} }) => {
  if (!storeId) {
    throw new Error('storeId is required to fetch store hours by date.');
  }
  try {
    let queryParams = {};
    if (!query || !query.offset || !query.limit) {
      queryParams = {
        ...query,
        offset: query?.offset || 0,
        limit: query?.limit || 10,
      };
    } else {
      queryParams = query;
    }
    return clientbookApi.get({
      url: `/merchants/stores/${storeId}/hoursbydate`,
      query: queryParams,
      loading,
      ...options,
    });
  } catch (error) {
    throw new Error(`Failed to fetch store hours by date: ${error.message}`);
  }
};

export const getStoreAvailability = async ({ storeId, query, loading = false, options = {} }) => {
  if (!storeId) {
    throw new Error('storeId is required to fetch store availability.');
  }
  if (!query?.startDate || !query?.endDate) {
    throw new Error('startDate and endDate are required to fetch store availability.');
  }
  try {
    return clientbookApi.get({
      url: `/merchants/stores/${storeId}/availability`,
      query,
      loading,
      ...options,
    });
  } catch (error) {
    throw new Error(`Failed to fetch store availability: ${error.message}`);
  }
};

export const saveStoreHoursByDate = async ({ storeId, data, loading = false, options = {} }) => {
  if (!storeId) {
    throw new Error('storeId is required to save store hours by date.');
  }
  if (!data) {
    throw new Error('data is required to save store hours by date.');
  }
  const { date, openTime, closeTime } = data;
  if (!date) {
    throw new Error('date is required in data to save store hours by date.');
  }
  try {
    return clientbookApi.put({
      url: `/merchants/stores/${storeId}/hoursbydate/${date}`,
      data: {
        openTime: openTime ? parseInt(openTime, 10) : null,
        closeTime: closeTime ? parseInt(closeTime, 10) : null,
      },
      loading,
      ...options,
    });
  } catch (error) {
    throw new Error(`Failed to save store hours by date: ${error.message}`);
  }
};

export const deleteStoreHoursByDate = async ({ storeId, date, loading = false, options = {} }) => {
  if (!storeId) {
    throw new Error('storeId is required to delete store hours by date.');
  }
  if (!date) {
    throw new Error('date is required to delete store hours by date.');
  }
  try {
    return clientbookApi.delete({
      url: `/merchants/stores/${storeId}/hoursbydate/${date}`,
      loading,
      ...options,
    });
  } catch (error) {
    throw new Error(`Failed to delete store hours by date: ${error.message}`);
  }
};

export const getStoreHours = async ({ storeId, loading = false, options = {} }) => {
  if (!storeId) {
    throw new Error('storeId is required to fetch store hours.');
  }
  try {
    return clientbookApi.get({
      url: `/merchants/stores/${storeId}/hours`,
      loading,
      ...options,
    });
  } catch (error) {
    throw new Error(`Failed to fetch store hours: ${error.message}`);
  }
};
